import React from 'react';
import PropTypes from 'prop-types';
import GiftCardListingItem from './GiftCardListingItem';
import Loading from '../../../components/react/Loading';

const GiftCardListing = React.forwardRef(
  (
    {
      listing,
      goal,
      termsAndConditionsCtaLabel,
      termsAndConditionsCtaLink,
      loadingGiftCards,
      purchaseCtaLabel,
      error,
      initialized,
      noResultsMessage
    },
    ref
  ) => (
    <div className="container gift-card-listing">
      {initialized && !loadingGiftCards && !listing.length && (
        <div className="container gift-card-listing">{noResultsMessage}</div>
      )}
      {listing.length > 0 && (
        <>
          <div className="gift-card-listing__list" ref={ref}>
            {listing.map(listItem => (
              <GiftCardListingItem
                key={listItem.name}
                {...listItem}
                {...{
                  termsAndConditionsCtaLink,
                  termsAndConditionsCtaLabel,
                  purchaseCtaLabel
                }}
                goal={goal}
              />
            ))}
          </div>
          <Loading isLoading={loadingGiftCards} />
        </>
      )}
    </div>
  )
);

GiftCardListing.displayName = 'GiftCardListing';

GiftCardListing.propTypes = {
  listing: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      imageAltText: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      purchaseCtaLink: PropTypes.string.isRequired,
      purchaseCtaLabel: PropTypes.string.isRequired
    })
  ).isRequired,
  goal: PropTypes.object,
  termsAndConditionsCtaLink: PropTypes.string.isRequired,
  termsAndConditionsCtaLabel: PropTypes.string.isRequired,
  purchaseCtaLabel: PropTypes.string.isRequired,
  loadingGiftCards: PropTypes.bool,
  error: PropTypes.bool,
  initialized: PropTypes.bool,
  noResultsMessage: PropTypes.string.isRequired
};

export default React.memo(GiftCardListing);
